module.exports = __webpack_public_path__ + "img/header.e4baa4be.jpg";